import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { InvestorBrowse } from '../Models/investor-browse';
import { Router } from '@angular/router';

declare const InvestorBrowseBorrowingPageLoad: any;
declare function PDFWelcomeMessage(eventId): any;
declare function FLFinancialStatementresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceForInvestorBrowseBorrowingDocCount(DocumentCount, innerText, outstanding): any;
declare function voiceForLastInvestorDocument(): any;
declare function FontSizeSettings(): any;
declare function CancelVoice(): any;
var IsLoadFontSizeSettings = 0;
var documentTabIndex = 0;

@Component({
  selector: 'app-investor-browse-borrowing-documents',
  templateUrl: './investor-browse-borrowing-documents.component.html',
  styleUrls: ['./investor-browse-borrowing-documents.component.css']
})
export class InvestorBrowseBorrowingDocumentsComponent implements OnInit {
  pathname = '';  

  constructor(private browseobligorService: BrowseobligorService, private router: Router) { }

  showModal(documentLink, tabindex) {
    debugger;    
    var w = 1000;
    var h = 800;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    // add inline if not in api part
    if (!documentLink.includes("inline")) {
      documentLink = documentLink + "&inline=1";
    }
    window.open(documentLink, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    PDFWelcomeMessage("");
    documentTabIndex = tabindex;
  }

  onClickInvestorBrowseBorrowing(outstanding) {
    debugger;
    if (outstanding == true) {
      document.getElementById("PageOverviewObligar").innerText = "Current Issues";
      document.getElementById("spnPageOverviewObligar").innerText = "Current Issues";
      this.loadInvestorBrowseBorrowingDocuments(localStorage.OBLIGOR_ID, "true", "1");
    }
    if (outstanding == false) {
      document.getElementById("PageOverviewObligar").innerText = "Issues No Longer Outstanding";
      document.getElementById("spnPageOverviewObligar").innerText = "Issues No Longer Outstanding";
      this.loadInvestorBrowseBorrowingDocuments(localStorage.OBLIGOR_ID, "false", "1");
    }        
    document.getElementById("lblObligar").focus();
    return;
  }

  onKeyUpDocument(event: any, documentLink, tabindex) {
    debugger;
    if (event.keyCode == 13) {
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      // add inline if not in api part
      if (!documentLink.includes("inline")) {
        documentLink = documentLink + "&inline=1";
      }
      window.open(documentLink, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
      documentTabIndex = tabindex;
    }
  }

  onKeyUp(event: any, filingType, filingTypeName) {
    debugger;
    if (event.target.id == "tblOverPageObligar" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, "tdInvestordocumentDesc", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tdInvestordocumentDesc").focus();
      return;
    }

    if (event.target.id == "DocumentOverviewCategories" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }

    if (event.target.id == "CurrentIssues" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }

    if (event.target.id == "CurrentNoIssues" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }    

    var finalDocumentLinkID = "";
    if (event.target.id.includes("_")) {
      var tdDocumentLinkID = event.target.id;
      var remove_after = tdDocumentLinkID.indexOf('_');
      finalDocumentLinkID = tdDocumentLinkID.substring(0, remove_after);
    }

    if ((event.target.id == "tdInvestordocumentDesc" || finalDocumentLinkID == "tdInvestorDocumentLink") && (event.keyCode == 9)) {
      event.preventDefault();
      return;
    }

    if (event.keyCode == 13 && finalDocumentLinkID == "tdInvestorDocumentLink") {
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      window.open("Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
      //documentTabIndex = filingTypeName;
      return;
    }
    // Call API when press Enter on Menu
    if (event.keyCode == 13 && (event.target.id == "CurrentIssues" || event.target.id == "CurrentNoIssues")) {

      if (event.target.id == "CurrentIssues") {
        CancelVoice();
        document.getElementById("PageOverviewObligar").innerText = "Current Issues";
        document.getElementById("spnPageOverviewObligar").innerText = "Current Issues";
        this.loadInvestorBrowseBorrowingDocuments(localStorage.OBLIGOR_ID, "true", "1");
      }
      if (event.target.id == "CurrentNoIssues") {
        CancelVoice();
        document.getElementById("PageOverviewObligar").innerText = "Issues No Longer Outstanding";
        document.getElementById("spnPageOverviewObligar").innerText = "Issues No Longer Outstanding";
        this.loadInvestorBrowseBorrowingDocuments(localStorage.OBLIGOR_ID, "false", "1");
      }  
      //document.getElementById("PageOverviewObligar").innerText = filingTypeName;
      document.getElementById("lblObligar").focus();
      return;
    }

    if (event.keyCode != 17) {
      if (event.keyCode == 27) {
        document.getElementById("DocumentOverviewCategories").focus();
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentOverviewCategories").innerText, document.getElementById("DocumentOverviewCategories").id, event.target.type, document.getElementById("DocumentOverviewCategories").title, event.target.htmlFor, event.target.alt, event.key);
        //document.getElementById("SkipMainContentfooter").focus();
        //BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
      if (event.keyCode == 9) {
        if (event.target.id == "DocumentOverviewCategories") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "CurrentIssues") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "EventNoticesID") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "CurrentNoIssues") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "lblObligar") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "PageOverviewObligar") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "tdInvestordocumentDesc") {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
      if (event.keyCode == 13) {
        if (event.target.id == "CurrentIssues") {
          document.getElementById("lblObligar").focus();
          document.getElementById("lblObligar").tabIndex = 151;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);

        }
        if (event.target.id == "CurrentNoIssues") {
          document.getElementById("lblObligar").focus();
          document.getElementById("lblObligar").tabIndex = 151;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tdInvestordocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (finalDocumentLinkID == "tdInvestorDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, finalDocumentLinkID, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tdInvestordocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (finalDocumentLinkID == "tdInvestorDocumentLink") {
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            voiceForLastInvestorDocument();
            return;
          }
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, finalDocumentLinkID, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }          
        return;
      }
      else if (event.keyCode == 39) {
        if (event.target.id == "tdInvestordocumentDesc") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          var finaltdDocLinkID = "";
          if (target[0].id.includes("_")) {
            var tdDocLinkID = target[0].id;
            var remove_after = tdDocLinkID.indexOf('_');
            finaltdDocLinkID = tdDocLinkID.substring(0, remove_after);
          }
          if (finaltdDocLinkID == "tdInvestorDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              voiceForLastInvestorDocument();
              return;
            }
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerHTML.includes(true), finaltdDocLinkID, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (finalDocumentLinkID == "tdInvestorDocumentLink") {
          var obligorDescIndex = 0;
          $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
          if (finalDocumentLinkID == "tdInvestorDocumentLink") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              voiceForLastInvestorDocument();
              return;
            }
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
              BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tdInvestordocumentDesc", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
            }
          }
        }
      }
      else if (event.keyCode == 37) {      
        if (finalDocumentLinkID == "tdInvestorDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdInvestordocumentDesc") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (event.target.id == "tdInvestordocumentDesc") {
          var obligorDescIndex = 1;
          $(event.target).parent().prev().children("td").eq(obligorDescIndex).focus();
          if (event.target.id == "tdInvestordocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
              var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;              
              BrowseObligorsponsiveVoiceSpeak("", event.target.value, event.keyCode, innerText, "tdInvestorDocumentLink", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
            }
          }
        }
      }
    }
  };

  ngOnInit() {
    debugger;
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    InvestorBrowseBorrowingPageLoad();
    this.pathname = window.location.pathname;    
    var OBLIGOR_DESC = localStorage.OBLIGOR_DESC;
    document.getElementById("lblObligar").innerText = OBLIGOR_DESC;
    document.getElementById("spnlblObligar").innerText = OBLIGOR_DESC;
    // Check for Investor Browse Borrowing Documents
    this.checkIssuesNoLongerOutstanding(localStorage.OBLIGOR_ID, "false", "0");
    
    this.loadInvestorBrowseBorrowingDocuments(localStorage.OBLIGOR_ID, "true", "0");    
  }

  setFontSizeSettings() {    
    if (IsLoadFontSizeSettings == 1) {
      FontSizeSettings();
      IsLoadFontSizeSettings = 0;
    }
  }
  
  public InvestorBrowseFilings: InvestorBrowse;
    
  checkIssuesNoLongerOutstanding(obligorId: string, outstanding: string, documentCountVoice: string) {
    this.browseobligorService.GetInvestorBrowseBorrowingDocuments(obligorId, outstanding).subscribe(data => {
      debugger;
      if (data['length'] == 0) {
        document.getElementById("CurrentNoIssues").style.display = "none";
      }
    }, error => {
      console.log(error);
      debugger;
      if (error.status == "403") {
        sessionStorage.removeItem("sessionData");
        this.checkSession_onSearch();
      }
    });
  }

  // load Investor Browse Borrowing Documents
  loadInvestorBrowseBorrowingDocuments(obligorId: string, outstanding: string, documentCountVoice: string) {
    this.browseobligorService.GetInvestorBrowseBorrowingDocuments(obligorId, outstanding).subscribe(data => {
      debugger;
      if (data['length'] == 0) {
        document.getElementById("CurrentIssues").style.display = "none";
      }
      if (data['length'] > 0) {
        // Speak for how many documents are in each category.
        if (documentCountVoice == "1") {
          voiceForInvestorBrowseBorrowingDocCount(data['length'], localStorage.OBLIGOR_DESC, outstanding);
        }
        IsLoadFontSizeSettings = 1;
        this.InvestorBrowseFilings = data;
      }
    }, error => {
      console.log(error);
      debugger;
      if (error.status == "403") {
        sessionStorage.removeItem("sessionData");
        this.checkSession_onSearch();
      }
    });
  }

  checkSession_onSearch() {
    // check session on search click
    if (!sessionStorage['sessionData']) {
      this.router.navigate(['registration']);
      return;

    }
  }
}
